(function () {
	'use strict';

	angular
        .module('signalrControllers')
        .factory('ChatService', service);

	service.$inject = ['$rootScope', 'Hub', '$timeout', 'configurationService'];

	function service($rootScope, Hub, $timeout, configurationService) {

	    var Chats = this;

	    //Chat ViewModel
	    var Chat = function (chat) {
	        if (!chat) chat = {};

	        var Chat = {
	            UserName: chat.UserName || 'UserX',
	            IconUrl: chat.IconUrl || 'IconZ',
	            ChatMessage: chat.ChatMessage || 'MessageY'
	        }

	        return Chat;
	    }

	    var hub = undefined;

	    function notifyMe(userName, iconUrl, chatMessage) {
	        var notifyMsg = userName + ': ' + chatMessage;
	        var options = {
	            body: chatMessage,
	            icon: iconUrl
	        }

	        // Let's check if the browser supports notifications
	        if (!("Notification" in window)) {
	            alert("This browser does not support desktop notification");
	        }

	            // Let's check whether notification permissions have already been granted
	        else if (Notification.permission === "granted") {
	            // If it's okay let's create a notification
	            var notification = new Notification(notifyMsg, options);
	        }

	            // Otherwise, we need to ask the user for permission
	        else if (Notification.permission !== 'denied') {
	            Notification.requestPermission(function (permission) {
	                // If the user accepts, let's create a notification
	                if (permission === "granted") {
	                    var notification = new Notification(notifyMsg, options);
	                }
	            });
	        }

	        // At last, if the user has denied notifications, and you 
	        // want to be respectful there is no need to bother them any more.
	    }

	    configurationService.getAppSettings()
              .then(function (appSettings) {

                  var rootPath = appSettings['CACMServices.URL'] + 'signalr'

                  //Hub setup
                  hub = new Hub("chatHub", {
                      listeners: {
                          'addNewMessageToPage': function (userName, iconUrl, chatMessage) {
                              Chats.add(userName, iconUrl, chatMessage);
                              notifyMe(userName, iconUrl, chatMessage);
                              $rootScope.$apply();
                          }
                      },
                      methods: ['send'],
                      rootPath: rootPath,
                      errorHandler: function (error) {
                          console.error(error);
                      },
                      hubDisconnected: function () {
                          if (hub.connection.lastError) {
                              hub.connection.start();
                          }
                      },
	        
                      logging: true
                  });
              });

	    Chats.all = [];
	    Chats.add = function (userName, iconUrl, chatMessage) {
	        Chats.all.push(new Chat({ UserName: userName, IconUrl: iconUrl, ChatMessage: chatMessage }));
	    }
	    Chats.send = function (userName, iconUrl, chatMessage) {
	        hub.send(userName, iconUrl, chatMessage);
	    }

	    return Chats;
	}
})();